import DropDown from '../../../../../src/components/DropDown';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faInfo } from '@fortawesome/pro-solid-svg-icons';
import { useEffect, useState } from 'react';
import { useGetMathSkillFiltersMutation } from '../../../../features/authentication/questionSearchApiSlice';
import CustomToast from '../../../../components/Toast';
import { NavLink, useParams } from 'react-router-dom';
import AddRandomMathSkillQuestions from './AddRandomMathSkillQuestions';

const MathSkills = () => {
  const [getMathSkillFilters] = useGetMathSkillFiltersMutation();
  const [courses] = useState(
    [
      { id: 26, name: 'Elementary Mathematics' },
      { id: 14, name: 'Intermediate Mathematics' }
    ]);
  const [levels, setLevels] = useState([]);
  const [topics, setTopics] = useState([]);
  const [allTopics, setAllTopics] = useState([]);
  const [skills, setSkills] = useState([]);
  const [mathSkillFilters, setMathSkillFilters] = useState([]);

  const [selectedCourseId, setSelectedCourseId] = useState(26);
  const [selectedLevelId, setSelectedLevelId] = useState(1);
  const [selectedTopicId, setSelectedTopicId] = useState(-1);
  const [selectedSkillId, setSelectedSkillId] = useState(-1);
  const { assignmentId } = useParams();

  useEffect(() => {
    getMathSkillFiltersAsync();
  }, [selectedCourseId]);

  const getMathSkillFiltersAsync = async () => {
    const option = {
      courseId: selectedCourseId
    };
    const response = await getMathSkillFilters(option);
    if (response.error) {
      CustomToast(response.error.data.error, 'error');
    }
    else {
      setMathSkillFilters(response.data);
      setLevels(response.data.levels);
      const currentLevelId = response.data.levels[0].id;
      setSelectedLevelId(currentLevelId);
      var distinctTopics = getDistinctTopics(response.data.topics);
      updateTopics(currentLevelId, response.data, distinctTopics);
      setAllTopics(distinctTopics);
    }
  };

  const getDistinctTopics = (topics) => {
    const distinct = topics.reduce((acc, current) => {
      const x = acc.find(item => item.name === current.name);
      if (!x) {
        return acc.concat([current]);
      } else {
        return acc;
      }
    }, []);
    return distinct.map((item, index) => ({ ...item, id: index + 1 }));
  };

  const handleSelectLevel = (currentLevelId) => {
    setSelectedLevelId(currentLevelId);
    updateTopics(currentLevelId, mathSkillFilters, allTopics);
  };

  const handleSelectTopic = (currentTopicId) => {
    const currentTopic = topics.filter((item) => item.id === currentTopicId);
    setSelectedTopicId(currentTopicId);
    updateSkills(selectedLevelId, currentTopic[0].topicId, mathSkillFilters);
  };

  const updateTopics = (currentLevelId, skillFilters, allTopics) => {
    const currentTopics = [];
    const newTopics = skillFilters.topics.filter(item => item.levelId === currentLevelId);
    newTopics.forEach(item => {
      const matchedTopic = allTopics.find(topic => topic.name === item.name);
      if (matchedTopic) {
        currentTopics.push({ ...item, id: matchedTopic.id });
      }
    });
    setTopics(currentTopics);
    setSelectedTopicId(currentTopics[0].id);
    updateSkills(currentLevelId, currentTopics[0].topicId, skillFilters);
  };

  const updateSkills = (currentLevelId, currentTopicId, skillfilters) => {
    const skillObj = {
      id: -1,
      name: 'All Skills'
    };
    const currentSkills = skillfilters.skills.filter((item) => IsLevel(item.levels, currentLevelId) && item.topicId === currentTopicId);
    const updatedSkills = [skillObj, ...currentSkills];
    setSkills(updatedSkills);
    setSelectedSkillId(-1);
  };

  function IsLevel(skillLevel, currentLevelId) {
    switch (currentLevelId) {
    case 1:
      if ((skillLevel & 1) != 0) return true; break;
    case 2:
      if ((skillLevel & 2) != 0) return true; break;
    case 4:
      if ((skillLevel & 4) != 0) return true; break;
    }
    return false;
  }


  return (
    <>
      <div className="white-card">
        <div className='d-flex gap-3'>
          <FontAwesomeIcon icon={faInfo} className="icon-info-circle" /><div className="mb-0">
            Select Difficult level and a Topic and Skill. Then use the buttons below to either browse questions or randomly add questions into your assignment.
          </div>
        </div>
        <div className='w-100 d-flex gap-3 mt-5'>
          <div className='w-100'>
            <DropDown
              key='math-course-dropdown'
              label='Course'
              value={courses}
              selectedValue={selectedCourseId}
              onChangeHandler={(e) => setSelectedCourseId(parseInt(e.target.value))}
            />
          </div>
          <div className='d-flex w-100'>
            <div className='w-100'>
              <DropDown
                key='math-level-dropdown'
                label='Difficulty Level'
                value={levels}
                selectedValue={selectedLevelId}
                onChangeHandler={(e) => handleSelectLevel(parseInt(e.target.value))}
              />
            </div>
          </div>
          <div className='w-100'>
            <DropDown
              key='math-topic-dropdown'
              label='Topics'
              value={topics}
              selectedValue={selectedTopicId}
              onChangeHandler={(e) => handleSelectTopic(parseInt(e.target.value))}
            />
          </div>
          <div className='w-100'>
            <DropDown
              key='math-course-dropdown'
              label='Skills'
              value={skills}
              selectedValue={selectedSkillId}
              onChangeHandler={(e) => setSelectedSkillId(parseInt(e.target.value))}
            />
          </div>
        </div>
        <h1 className='mt-5'>Add Questions</h1>
        <div className='d-flex gap-2 mt-4 h-auto'>
          <div className='light-border-box w-100'>
            <h6>Browse Questions and Select Individually</h6>
            <div className='mt-5'>
              Browse questions that match the Question Criteria and select the individual questions to add to the assignment.
            </div>
            <NavLink
              to={'math_skills_questions'}
              state={{ assignmentId: assignmentId, selectedCourseId: selectedCourseId, selectedLevelId: selectedLevelId, selectedTopicId: selectedTopicId, selectedSkillId: selectedSkillId }}
            >
              <button className='btn btn-castleRed mt-5'>Browse and Select Questions Individually</button>
            </NavLink>
          </div>
          <div className='light-border-box w-100'>
            <h6>Add Randomly Selected Questions Automatically</h6>
            <div className='mt-5'>
              Questions that match the selected unit and skill(s) are selected randomly and added to the assignment.
              An assignment is limited to 100 questions.
              The actual number of questions added may be less depending on your selection criteria.
            </div>
            
            <div className='mt-4'>
              <AddRandomMathSkillQuestions
                selectedCourseId={selectedCourseId}
                selectedLevelId={selectedLevelId}
                selectedSkillId={selectedSkillId}
                selectedTopicId={selectedTopicId}
              />
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default MathSkills;
